<template>
  <div style="width: 100%; height: 100%; position: relative">
    <div v-if="!isNull">
      <div :style="{ width: '100%', height: height }" :id="id"></div>
      <div v-if="this.type === 2">
        <div
          class="percent"
          :class="positionClass"
          v-if="percent && percent >= 0"
        >
          {{ percent }}%
        </div>
      </div>
      <div v-if="this.type === 1 && this.option.length">
        <div class="text3" v-show="this.allmoney">
          <div>{{ this.totalText }}</div>
          <div>{{ this.allmoney }}{{ unit }}</div>
        </div>
        <div class="text3" v-show="!this.allmoney">
          <div v-if="id === 'pie4' || id === 'pie5' || id === 'pie6'">
            No Total Data
          </div>
          <div v-else>No Total Data</div>
        </div>
      </div>
    </div>
    <div v-if="isNull" :style="{ height: height }" class="nostr">No Data</div>
  </div>
</template>

<script>
import echarts from "echarts";

export default {
  name: "ChartPie",
  props: {
    color: {
      type: Array,
      default() {
        return [
          "#FCA900",
          "#FDBC38",
          "#29C43F",
          "#6ED17C",
          "#5BF7F0",
          "#00EEE2",
          "#709BFF",
          "#437BFF",
          "#4C56FF",
          "#313CFF",
          "#B44FFF",
          "#9300FF"
        ];
      }
    },
    id: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: ""
    },
    keyName: {
      type: String,
      default: ""
    },
    keyCount: {
      type: String,
      default: ""
    },
    unit: {
      type: String,
      default: "Pc"
    },
    type: {
      type: Number, // 中心是否显示 1是显示
      default: 1
    },
    position: {
      // 是否显示 1是显示
      type: Number,
      default: 1
    },
    option: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      allmoney: 0,
      totalText: "",
      percent: null,
      total: null,
      isNull: true
    };
  },
  computed: {
    positionClass() {
      if (this.position === 1) {
        return {
          text1: true
        };
      } else if (this.position === 2) {
        return {
          text2: true
        };
      }
    },
    legendStyleConfig() {
      if (this.position === 1) {
        return {
          bottom: 5,
          left: "center"
        };
      } else if (this.position === 2) {
        return {
          right: 35,
          top: "center"
        };
      }
    },
    seriesLabelConfig() {
      if (this.position === 1) {
        return {
          show: true,
          color: "#000",
          fontSize: 10,
          formatter: params => {
            if (this.type === 2) {
              if (params.data.name == "Primary industry") {
                return `${params.data.name} ${params.percent}%\n${params.data.value} ${this.unit}`;
              } else {
                return `${params.data.name}\n ${params.percent}%\n${params.data.value}\n${this.unit}`;
              }
            } else {
              // if(params.data.name = )
              let str = params.data.name.split(" ");
              let strc = str.length / 2;
              let first = str.slice(0, strc).toString();
              let last = str.slice(strc).toString();
              // return `${first}\n${last}\n Total：\n${params.data.value}\n${this.unit} \nProportion：\n${params.percent}%`
              return `Total：\n${params.data.value}\n${this.unit} \nProportion：\n${params.percent}%`;
            }
          }
        };
      } else if (this.position === 2) {
        return {
          show: false
        };
      }
    }
  },
  methods: {},
  watch: {
    option: {
      handler(newVal) {
        if (newVal.length) {
          this.$nextTick(() => {
            let seriesData = [];
            let legendData = [];
            let value = [];
            newVal.forEach(item => {
              if (item.hasOwnProperty(this.keyCount)) {
                seriesData.push({
                  value: item[this.keyCount],
                  name: item[this.keyName]
                });
                legendData.push(item[this.keyName]);
                value.push(item[this.keyCount]);
              }
              // const count = parseFloat(item[this.keyCount])
              // this.total += count
            });
            let item = undefined;
            let tmxTotal = newVal[newVal.length - 1].tmxTotal;
            item = value.find(ele => {
              return ele !== null && !isNaN(ele) && ele !== undefined;
            });
            if (item == undefined) {
              if (
                tmxTotal !== null &&
                !isNaN(tmxTotal) &&
                tmxTotal !== undefined &&
                tmxTotal !== 0
              ) {
                seriesData = [
                  {
                    name: newVal[newVal.length - 1].tmxTotalName,
                    value: tmxTotal
                  }
                ];
                legendData = [newVal[newVal.length - 1].tmxTotalName];
                this.allmoney = tmxTotal;
                this.totalText = newVal[newVal.length - 1].tmxTotalName;
                this.isNull = false;
              } else {
                this.isNull = true;
                return
              }
            } else {
              this.allmoney = tmxTotal;
              this.totalText = newVal[newVal.length - 1].tmxTotalName;
              this.isNull = false;
            }

            const option = {
              color: this.color,
              // tooltip: {
              //   trigger: 'item',
              //   formatter: '{a} <br/>{b}: {c} ({d}%)'
              // },
              tooltip: {
                // trigger: 'item',
                trigger: "none",
                position: "right",
                backgroundColor: "rgba(255,255,255,0)",
                formatter: params => {
                  return `
                  <div style="position: relative;">
                      <div
                          style="background: #fff; padding: 8px 15px; border-radius: 4px; box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);">
                          <p style="margin: 0; color: #000; font-size: 14px;">
                              ${params.name}:
                               <span style="color: #409EFF">
                                  ${params.percent}
                              </span>
                              %
                          </p>
                      </div>
                      <div style="position: absolute; bottom: 0; left: 0; width: 100%; z-index: 3; height: 10px; background: #fff; border-radius: 4px;"></div>
                      <div style="position: absolute; bottom: -5px; left: 50%; z-index: 2; margin-left: -5px; width: 10px; height: 10px; background: #fff; transform: rotate(135deg); box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);"></div>
                  </div>
                `;
                }
              },
              legend: Object.assign(this.legendStyleConfig, {
                orient: this.position === 1 ? "horizontal" : "vertical",
                icon: "circle",
                itemWidth: 10,
                itemHeight: 10,
                itemGap: 10,
                data: legendData
              }),

              // legend: {
              //   orient: 'vertical',
              //   left: 10,
              //   icon: 'circle',
              //   itemWidth: 10,
              //   itemHeight: 10,
              //   itemGap: 10,
              //   data: legendData
              // },
              series: [
                {
                  // name: '各行业负面清单数占比',
                  type: "pie",
                  radius: this.type === 1 ? ["35%", "50%"] : ["40%", "60%"],
                  center: this.position === 1 ? ["50%", "45%"] : ["40%", "50%"],
                  avoidLabelOverlap: false,
                  legendHoverLink: false,
                  label: this.seriesLabelConfig,
                  emphasis: {
                    label: {
                      show: true,
                      color: "#000"
                    }
                  },
                  labelLine: {
                    show: true,
                    lineStyle: {
                      color: "#979797"
                    }
                  },
                  data: seriesData
                }
              ]
            };
            this.$nextTick(() => {
              const chart = echarts.init(document.getElementById(this.id));
              chart.setOption(option);
              if (this.type === 2) {
                chart.on("mouseover", params => {
                  this.percent = params.percent;
                });
                chart.on("mouseout", params => {
                  this.percent = null;
                });
              }
            });
          });
        } else {
          this.isNull = true;
        }
      },
      deep:true,
      immediate:true
    }
  },
  mounted() {
    const this_ = this;
    window.addEventListener("resize", () => {
      this_.$nextTick(() => {
        const chart = echarts.init(document.getElementById(this.id));
        chart.resize();
      });
    });
  }
};
</script>

<style scoped>
.percent {
  position: absolute;
  z-index: 9999;
  width: 100px;
  height: 32px;
  line-height: 32px;
  font-size: 25px;
  color: #000000;
  letter-spacing: -0.5px;
  text-align: center;
  font-weight: 400;
}

.text1 {
  left: 50%;
  top: 45%;
  margin-top: -16px;
  margin-left: -50px;
}

.text2 {
  left: 40%;
  top: 50%;
  margin-top: -16px;
  margin-left: -50px;
}

.text3 {
  position: absolute;
  z-index: 9;
  top: 50%;
  left: 50%;
  width: 200px;
  height: 48px;
  margin-left: -100px;
  margin-top: -36px;
  font-size: 15px;
  color: #000000;
  letter-spacing: -0.5px;
  text-align: center;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.text3 > div {
  line-height: 24px;
}

.nostr {
  position: relative;
  top: 0;
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  height: 100%;
  width: 100%;
}
</style>
